import emptyIcon from 'assets/images/explore-learnings/empty-icon.svg'

export const EmptyResult = () => {
  return (
    <div className="flex max-w-[1120px] mx-auto flex-col text-center font-TCCC pt-[64px] pb-[72px]">
      <img src={emptyIcon} alt="Empty" className="w-[136px] h-[75px] mx-auto mb-6" />
      <p className="text-14 font-semibold mb-2">No results for this search</p>
      <p className="text-14 text-[#505050]">
        There are no results for this search, try another one or use different filters.
      </p>
    </div>
  )
}
